import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Checkbox } from '../components/ui/checkbox';
import { useToast } from '../hooks/use-toast';
import Seo from '../components/Seo';

const MiCuenta = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const { toast } = useToast();

  const handleLogin = (e) => {
    e.preventDefault();
    // Mock: guardar en localStorage
    localStorage.setItem('usuario', JSON.stringify({ email, loggedIn: true }));
    toast({
      title: "Inicio de sesión exitoso",
      description: `Bienvenido ${email}`
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <Seo title="Mi cuenta" robots="noindex, nofollow" />
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto">
          <Card>
            <CardHeader>
              <CardTitle className="text-2xl text-center">Mi Cuenta</CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleLogin} className="space-y-4">
                <div>
                  <Label htmlFor="email">Correo electrónico</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <Label htmlFor="password">Contraseña</Label>
                  <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="••••••••"
                  />
                </div>

                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="remember"
                    checked={remember}
                    onCheckedChange={setRemember}
                  />
                  <Label htmlFor="remember" className="text-sm cursor-pointer">
                    Recordarme
                  </Label>
                </div>

                <Button type="submit" className="w-full">
                  Iniciar Sesión
                </Button>

                <div className="text-center">
                  <button
                    type="button"
                    className="text-sm text-gray-600 hover:text-black"
                    onClick={() => alert('Funcionalidad en desarrollo')}
                  >
                    ¿Olvidaste tu contraseña?
                  </button>
                </div>
              </form>

              <div className="mt-6 pt-6 border-t">
                <p className="text-center text-sm text-gray-600 mb-4">
                  ¿No tienes cuenta?
                </p>
                <Button variant="outline" className="w-full">
                  Registrarse
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MiCuenta;
